import script from "./CatalogBlock.vue?vue&type=script&setup=true&lang=js"
export * from "./CatalogBlock.vue?vue&type=script&setup=true&lang=js"

import "./CatalogBlock.vue?vue&type=style&index=0&id=0b9d08d3&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0b9d08d3"]])

export default __exports__